<div class="ga-strip" *ngIf="agent">
  <div class="ga-head">
    <span class="ga-dot" [class.ga-live]="activeJobs.length > 0"></span>
    <span class="ga-title">{{ heading }}</span>
    <span class="ga-state" *ngIf="activeJobs.length; else idle">working</span>
    <ng-template #idle><span class="ga-state ga-idle">idle</span></ng-template>
  </div>

  <div class="ga-jobs" *ngIf="activeJobs.length">
    <div class="ga-job" *ngFor="let job of activeJobs" [class.ga-new]="isFresh(job)">
      <span class="ga-spin" *ngIf="job.status === 'Running'"></span>
      <span class="ga-job-label">{{ jobLabel(job) }}</span>
      <span class="ga-job-status">{{ job.status }}</span>
      <ng-container *ngIf="jobProgress(job) as pct">
        <span class="ga-bar"><span class="ga-fill" [style.width.%]="pct"></span></span>
        <span class="ga-pct">{{ job.progressDone }}/{{ job.progressTotal }}</span>
      </ng-container>
      <button type="button" class="br-btn br-btn--outline-danger br-btn--sm ga-stop" [disabled]="stopping.has(job.publicId)"
              (click)="stopJob(job)"
              [title]="stopping.has(job.publicId)
                ? 'Asking it to stop…' : 'Stop this job'">
        {{ stopping.has(job.publicId) ? 'stopping…' : 'stop' }}
      </button>
    </div>
  </div>

  <!-- What the agent got through in the last 24h. -->
  <div class="ga-counters" *ngIf="hasThroughput">
    <span class="ga-counter" *ngFor="let t of visibleThroughput">
      <b>{{ t.processed }}</b> {{ throughputLabel(t) }}
    </span>
    <span class="ga-counters-window">last 24h</span>
  </div>

  <div class="ga-tail">
    <span class="ga-recent" *ngFor="let job of recentLatest"
          [class.ga-failed]="job.status === 'Failed'" [class.ga-new]="isFresh(job)"
          [title]="finishedAt(job)">
      {{ jobLabel(job) }} · {{ job.status }}<ng-container *ngIf="job.progressDone"> · {{ job.progressDone }}</ng-container>
    </span>
    <span class="ga-gates">
      <button type="button" class="br-btn br-btn--outline-primary br-btn--sm ga-gate" *ngIf="agent.pendingApprovals"
              (click)="openApprovals()">{{ agent.pendingApprovals }} awaiting approval</button>
      <button type="button" class="br-btn br-btn--outline-primary br-btn--sm ga-gate" *ngIf="agent.pendingReviews"
              (click)="openReviewQueue()">{{ agent.pendingReviews }} identity reviews</button>
    </span>
  </div>
</div>
